export default __webpack_public_path__ + "static/media/gallery-wip-emitter_07.a166cf44.jpg";